export default __webpack_public_path__ + "static/media/capabilities-mobile.790861ec.png";